import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { AuthorizedRouteData } from '../app-routing.module';
import { IdentityStore, IdentityStoreType } from '../app-state/identity/identity.store';

export const PermissionsGuard = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const identityStore: IdentityStoreType = inject(IdentityStore);
  const router: Router = inject(Router);

  return toObservable(identityStore.isLoading).pipe(
    filter(isLoading => !isLoading),
    map(() => {
      const { permissions }: AuthorizedRouteData = route.data as AuthorizedRouteData;

      if (!permissions || (!permissions.menuAccess?.length && !permissions.oneAtLeast?.length)) {
        return true;
      }

      const hasUserPermissions = identityStore.hasPermissionToAccessPage({
        menuAccess: permissions.menuAccess,
        oneAtLeast: permissions.oneAtLeast,
      });

      if (!hasUserPermissions) {
        router.navigate(['dashboard']);
      }

      return hasUserPermissions;
    }),
  );
};
